const state = {
  trajectories: {},
  isLoading: false,
  filters: {},
  selectedFilter: ''
}

const mutations = {
  setLoading (state, data) {
    state.isLoading = data
  },
  updateFilter (state, data) {
    state.filters = Object.assign({}, data)
  },
  setSelectedFilter (state, data) {
    state.selectedFilter = data
  }
}

const getters = {
  objectTypes: state => {
    let options = []
    if (state.trajectories.hasOwnProperty('features')) {
      if (state.trajectories.features.length > 0) {
        state.trajectories.features.forEach(item => {
          if (options.indexOf(item.properties.ObjectType) === -1) {
            options.push(item.properties.ObjectType)
          }
        })
      }
    }
    return options
  },
  trajects: state => {
    let options = []
    if (state.trajectories.hasOwnProperty('features')) {
      if (state.trajectories.features.length > 0) {
        state.trajectories.features.forEach(item => {
          if (options.indexOf(item.properties.traject) === -1) {
            options.push(item.properties.traject)
          }
        })
      }
    }
    return options
  },
  getFilters: state => {
    return state.filters
  },
  getMapCenter: state => {
    return [51.9964998, 4.2913794]
  }
}

const actions = {
  setFilter ({commit}, data) {
    commit('updateFilter', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/projects.js